<app-widget-base-detail [baseDetailComponent]="this"> </app-widget-base-detail>
